module.exports = __webpack_public_path__ + "img/T1B_rc_19.68d6e2db.png";